"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMask = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_text_mask_1 = tslib_1.__importDefault(require("react-text-mask"));
var getOr_1 = tslib_1.__importDefault(require("lodash/fp/getOr"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/fp/isFunction"));
exports.TextMask = function (props) {
    var inputRef = props.inputRef, _a = props.mask, mask = _a === void 0 ? [] : _a, _b = props.keepCharPositions, keepCharPositions = _b === void 0 ? false : _b, _c = props.guide, guide = _c === void 0 ? false : _c, _d = props.placeholderChar, placeholderChar = _d === void 0 ? '\u2000' : _d, rest = tslib_1.__rest(props, ["inputRef", "mask", "keepCharPositions", "guide", "placeholderChar"]);
    var handleRef = react_1.useCallback(function (ref) {
        if (isFunction_1.default(inputRef)) {
            var inputElement = getOr_1.default(null, 'inputElement', ref);
            inputRef(inputElement);
        }
    }, [inputRef]);
    return (react_1.default.createElement(react_text_mask_1.default, tslib_1.__assign({}, rest, { mask: mask, ref: handleRef, placeholderChar: placeholderChar, keepCharPositions: keepCharPositions, guide: guide })));
};
exports.TextMask.displayName = 'FOS_TextMask';
